import React, { memo, useMemo } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import { PAYMENT_OPTIONS_CONSTANTS } from "./constant";
import { getObjectNameByCardType, processCard } from "./helpers";
import PaymentOptionCard from "./PaymentOptionCard";
import {
    Container,
    PaymentOptionsContainer,
    Separator,
    SeparatorLine,
    SeparatorText,
} from "./styled";
import { IPaymentOptionsProps, IPaymentCard } from "./types";
import { BackButton } from "../BackButton";

const PaymentOptions = memo(
    ({
        cards,
        shownOfferLimit = 2,
        onBackClick,
        onPaymentCTAClick,
        onPaymentCardClickAnalytics,
    }: IPaymentOptionsProps) => {
        const processedCards = useMemo(() => {
            return cards?.map((card) => processCard({ card, shownOfferLimit }));
        }, [cards, shownOfferLimit]);

        if (isEmpty(processedCards)) {
            return null;
        }

        const handlePaymentCardClick = (card: IPaymentCard, index: number) => {
            const objectName = getObjectNameByCardType(card.type);
            onPaymentCardClickAnalytics?.(card, index, objectName);
            onPaymentCTAClick(card);
        };

        return (
            <Container>
                <BackButton
                    accessibilityLabel="Go back"
                    hasScrolledBackground={true}
                    onClick={onBackClick}
                    title={PAYMENT_OPTIONS_CONSTANTS.HEADER_TITLE}
                    position="relative"
                />

                <PaymentOptionsContainer>
                    {processedCards?.map((card, index) => {
                        return (
                            <React.Fragment key={card.id}>
                                <PaymentOptionCard
                                    option={card}
                                    onButtonClick={() =>
                                        handlePaymentCardClick(card as IPaymentCard, index)
                                    }
                                />
                                {index < processedCards.length - 1 && (
                                    <Separator>
                                        <SeparatorLine />
                                        <SeparatorText variant="V2.overline.neutral.bold">
                                            {PAYMENT_OPTIONS_CONSTANTS.OR_SEPARATOR}
                                        </SeparatorText>
                                        <SeparatorLine />
                                    </Separator>
                                )}
                            </React.Fragment>
                        );
                    })}
                </PaymentOptionsContainer>
            </Container>
        );
    }
);

PaymentOptions.displayName = "PaymentOptions";

export default PaymentOptions;
